import { actions } from './doctor_cabinet/actions'
import { getters } from './doctor_cabinet/getters'
import { state } from './doctor_cabinet/state'
import { mutations } from './doctor_cabinet/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
